<template>
    <div>
        <div class="hero">
            <div class="hero-carousel">
                <swiper :options="swiperOption1">
                    <!--                    <swiper-slide v-for="banner in $root.sliders.banner"-->
                    <!--                                  :key="banner.id"-->
                    <!--                                  ref="teste">-->
                    <!--                        <lazy-image class="hero-slide" bg-mode :image="banner" alt=""/>-->
                    <!--                    </swiper-slide>-->
                    <swiper-slide>
                        <a href="https://wa.me/5543999590178"
                           target="_blank">
                            <img class="hero-slide" src="@/assets/backgrounds/banner-1.jpg" alt="">
                        </a>
                    </swiper-slide>
                    <swiper-slide>
                        <a href="https://homolog.fibrillare.com.br/produtos/balancos-suspensos"
                        target="_blank">
                            <img class="hero-slide" src="@/assets/backgrounds/banner-2.jpg" alt="">
                        </a>
                    </swiper-slide>
                    <swiper-slide>
                        <a href="https://homolog.fibrillare.com.br/produtos/sofas"
                        target="_blank">
                            <img class="hero-slide" src="@/assets/backgrounds/banner-3.jpg" alt="">
                        </a>
                    </swiper-slide>
                    <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
                </swiper>
            </div>
            <img class="mouse" src="@/assets/icons/mouse.svg" alt="">
        </div>
    </div>
</template>

<script>
    import 'swiper/dist/css/swiper.css';
    import {swiper, swiperSlide} from 'vue-awesome-swiper';

    export default {
        name: "HomeHero",
        data() {
            return {
                locaBanners: [],
                swiperOption1: {
                    spaceBetween: 30,
                    effect: 'fade',
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: false
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
    }
</script>

<style lang="scss" scoped>
    .fixed-content {
        z-index: 10;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate3d(-50%, -40%, 0);
    }

    .hero-slide {
        background-size: cover;
        background-color: #E3E3E3;
        background-position: center center;
        background-repeat: no-repeat;
        object-fit: cover;
        height: 100%;
        width: 100%;
    }

    .hero {
        position: relative;
        margin-top: 65px;
        height: calc(100vh - 65px);
    }

    .hero-carousel {
        background-color: #E3E3E3;
        height: calc(100vh - 83px);
        position: relative;
    }

    .swiper-slide {
        background-position: center;
        background-size: cover;
        height: calc(100vh - 83px);
    }

    .mouse {
        position: absolute;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        bottom: 30px;
        z-index: 10;
        cursor: pointer;
    }

    @media only screen and (max-width: 1200px) {
        .hero {
            margin-top: 79px;
        }
    }

    @media only screen and (max-width: 1023px) {
        .hero {
            margin-top: 79px;
        }

        .hero-slide {
            background-size: cover;
        }

        /*.hero-carousel {*/
        /*    height: calc(270px - 79px);*/
        /*}*/

        /*.swiper-slide {*/
        /*    height: calc(270px - 79px);*/
        /*}*/
    }

    @media only screen and (max-width: 767px) {
        .hero {
            margin-top: 77px;
            height: calc(270px - 79px);
        }

        .hero-slide {
            background-size: contain;
        }

        .hero-carousel {
            height: calc(270px - 79px);
        }

        .swiper-slide {
            height: calc(270px - 79px);
        }

        .mouse {
            display: none;
        }

        .fixed-content {
            max-width: 70%;
        }
    }

    @media only screen and (min-width: 568px) and(max-width: 767px) {
        .hero {
            margin-top: 79px;
            height: calc(100vh - 79px);
        }

        .hero-carousel {
            height: calc(100vh - 79px);
        }

        .swiper-slide {
            height: calc(100vh - 79px);
        }
        .hero-slide {
            background-size: cover;
        }
    }
</style>
